import React from 'react';
import {ReactTableDefaults} from 'react-table';

export class PaginationOverride extends ReactTableDefaults.PaginationComponent {
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.page !== this.props.page) {
            this.setState({page: this.props.page});
        }
    }
}
